/**
 * base64转文件, 兼容IOS/MAC等, 放弃@dyb881/file
 * @param base64
 * @param fileName
 * @returns {Promise<Blob>}
 * @private
 */
export const imgBase64ToFile = (base64, fileName) => {
    const data = base64.split(",");
    const type = data[0].slice(5, -7);
    const ext = type.split("/")[1];
    const bstr = atob(data[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    let blob = new Blob([u8arr], { type: type });
    blob.lastModifiedDate = new Date();
    blob.name = `${fileName}.${ext}`;
    return Promise.resolve(blob);
};
// 电脑验证示例
export const getVerityImgTipList = () => {
    return [
        {
            label: "正确示例",
            img: require("@assets/img/img_tip1.png"),
        },
        {
            label: "面部不全",
            img: require("@assets/img/img_tip2.png"),
        },
        {
            label: "图像模糊",
            img: require("@assets/img/img_tip3.png"),
        },
        {
            label: "光线不当",
            img: require("@assets/img/img_tip4.png"),
        },
        {
            label: "面部遮挡",
            img: require("@assets/img/img_tip5.png"),
        },
    ];
};
/**
 * base64转文件, 兼容IOS/MAC等, 放弃@dyb881/file
 * @param base64 字符串
 * @param fileName 文件名
 * @returns {Promise<Blob>}
 * @private
 */
export const base64ToFile = (base64, fileName) => {
    const data = base64.split(",");
    const type = data[0].slice(5, -7);
    const ext = type.split("/")[1];
    const bstr = atob(data[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    let blob = new Blob([u8arr], { type: type });
    blob.lastModifiedDate = new Date();
    blob.name = `${fileName}.${ext}`;
    return Promise.resolve(blob);
};

/**
 * 过滤数据 通过身份和userid
 */
export const filterArrayListByUser = (soureList, user) => {
    if (!soureList || soureList.length == 0 || user == null) {
        return [];
    }
    const resultList = [];
    Object.assign(resultList, soureList);
    for (let i = 0; i < resultList.length; i++) {
        const item = resultList[i];
        // 如果身份和userid都相等
        // 有typeCode值表示是监督员
        const param = item.typeCode ? "typeCode" : "identityCode";
        //  lzb 2021-07-22  user里面固定是 identityCode  item里面根据参数不同而不同 学员 identityCode  管理员 typeCode
        if (item.userId == user.userId && item[param] == user.identityCode) {
            resultList.splice(i, 1);
            break;
        }
    }
    return resultList;
};
